import RentCollectionManagerProfile from "../Page/Manager/Rent/RentCollectionManagerProfile";
import RentDetailsManagerPr from "../Page/Manager/Rent/RentDetailsManagerPr";
// import TaskDetailsManagerProfile from "../Page/Manager/Task/TaskDetailsManagerProfile";
// import AddWorkerManagerProfile from "../Page/Manager/Worker/AddWorkerManagerProfile";
// import WorkerDetailsManagerProfile from "../Page/Manager/Worker/WorkerDetailsManagerProfile";
// import WorkerListManagerProfile from "../Page/Manager/Worker/WorkerListManagerProfile";

import AddProfileGobal from "../Components/Global/AddProfileGobal";
import DetailsProfileGlobal from "../Components/Global/DetailsProfileGlobal";
import ViewProfileListGlobal from "../Components/Global/ViewProfileListGlobal";
import AllPropertyList from "../Components/Payments/AllPropertyList";
import AllUnitList from "../Components/Payments/AllUnitList";
import BuildingDetails from "../Page/Owner/Building/BuildingDetails";
import Dashboard from "../Page/Owner/OwnerPartnerDashboard/Dashboard";
import RequestDetails from "../Page/Owner/Request/RequestDetails";
import AddTask from "../Page/Owner/Task/AddTask";
import TaskDetails from "../Page/Owner/Task/TaskDetails";
import Addunits from "../Page/Owner/Units/Addunits";
import UnitDetails from "../Page/Owner/Units/UnitDetails";

export const ManagertRoutes = [
  {
    path: "/managerdashboard",
    Component: <Dashboard key={44}  allowedRoles={["Manager"]} />,
    Title: "Managerdashboard",
  },
  {
    path: "/manager/addworker",
    Component: <AddProfileGobal key="manager/add" allowedRoles={["Manager"]} />,
    Title: "AddWorkerManagerProfile",
  },
  {
    path: "/manager/addworker/:id",
    Component: <AddProfileGobal key="manager/edit" allowedRoles={["Manager"]} />,
    Title: "AddWorkerManagerProfileid",
  },
  {
    path: "/manager/workerlist",
    Component: <ViewProfileListGlobal key="manager/view" allowedRoles={["Manager"]} />,
    Title: "WorkerListManagerProfile",
  },
  {
    path: "/manager/worker-details/:id",
    Component: <DetailsProfileGlobal key="manager/worker" allowedRoles={["Manager"]} />,
    Title: "WorkerDetailsManagerProfile",
  },
  {
    path: "/manager/addtask",
    Component: <AddTask key="manager/addtask" allowedRoles={["Manager"]} />,
    Title: "AddTaskManagerProfile",
  },
  {
    path: "/manager/addtask/:id",
    Component: <AddTask key="manager/addtask23" allowedRoles={["Manager"]} />,
    Title: "AddTaskManagerProfileid ",
  },
  {
    path: "/manager/tasklist",
    Component: <ViewProfileListGlobal key="manager/tasklist" allowedRoles={["Manager"]} />,
    Title: "TaskListTaskManagerProfile ",
  },
  {
    path: "/manager/task-details/:id",
    Component: <TaskDetails key="manager/task45" allowedRoles={["Manager"]} />,
    Title: "TaskDetailsManagerProfile ",
  },
  {
    path: "/manager/view-request",
    Component: <ViewProfileListGlobal key="manager/view" allowedRoles={["Manager"]} />,
    Title: "ViewRequestManagerProfile ",
  },
  {
    path: "/manager/request-details/:id",
    Component: <RequestDetails key="manager/request" allowedRoles={["Manager"]} />,
    Title: "RequestDetailsManagerProfile ",
  },
  {
    path: "/manager/buildinglist",
    Component: <ViewProfileListGlobal key="manager/buildinglist" allowedRoles={["Manager"]} />,
    Title: "ViewManagerBuildingList",
  },

  {
    path: "/manager/building-details/:id",
    Component: <BuildingDetails key="manager/building" allowedRoles={["Manager"]} />,
    Title: "ManagerBuildingDetails",
  },
  {
    path: "/manager/unit-details/:id",

    Component: <UnitDetails key="manager/unit" allowedRoles={["Manager"]} />,
    Title: "ManagerUnitDetails",
  },
  {
    path: "/manager/add-units/:id",
    Component: <Addunits key="manager/edit" allowedRoles={["Manager"]} />,
    Title: "ManagerUnitDetails",
  },
  {
    path: "manager/tenantlist",
    Component: <ViewProfileListGlobal key="manager/tenantlist" allowedRoles={["Manager"]} />,
    Title: "ViewTenantManagerProfile",
  },
  {
    path: "manager/tenant-details/:id",
    Component: <DetailsProfileGlobal key="manager/tenant" allowedRoles={["Manager"]} />,
    Title: "TenantDetailsManagerProfile",
  },
  {
    path: "manager/rent/collection-management",
    Component: <AllPropertyList
     key="manager/rent" allowedRoles={["Manager"]} />,
    Title: "PropertyListsManagerPr",
  },
  {
    path: "manager/collection-management/:id",
    Component: <AllUnitList  key="manager/collection" allowedRoles={["Manager"]} />,
    Title: "PropertyDetailsManagerPr",
  },
  {
    path: "manager/addtenant",
    Component: <AddProfileGobal key="manager/addtenant" allowedRoles={["Manager"]} />,
    Title: "AddTenantByManager",
  },
  {
    path: "manager/addtenant/:id",
    Component: <AddProfileGobal key="manager/edit" allowedRoles={["Manager"]} />,
    Title: "AddTenantByManagerid",
  },
  {
    path: "manager/rent-collection",
    Component: <RentCollectionManagerProfile key="manager/rent" allowedRoles={["Manager"]} />,
    Title: "RentCollectionManagerProfile",
  },
  {
    path: "manager/rent-collection/:id",
    Component: <RentDetailsManagerPr key="manager/rent" allowedRoles={["Manager"]} />,
    Title: "RentDetailsManagerPr",
  },
];
